"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from "react";
import { useRegistry } from "~/components/registry/registry-provider";
import DefaultHeaderMain from "./header-main-eon";

/**
 * Renders the client-specific header from the registry when provided (e.g. ECON),
 * otherwise the default E.ON header.
 */
export default function HeaderMainFromRegistry() {
  const $ = _c(3);
  const {
    components
  } = useRegistry();
  const RegistryHeader = (components as {
    HeaderMain?: ComponentType;
  }).HeaderMain;
  if (RegistryHeader) {
    let t0;
    if ($[0] !== RegistryHeader) {
      t0 = <RegistryHeader />;
      $[0] = RegistryHeader;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DefaultHeaderMain />;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}